import axios, { type AxiosResponse } from "axios";
import { baseUrl } from "./constants";

// MIME types for chat attachments
export type ChatAttachmentMimeType =
  | "application/pdf"
  | "application/msword"
  | "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  | "application/vnd.ms-excel"
  | "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  | "application/vnd.ms-powerpoint"
  | "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  | "text/plain"
  | "text/csv"
  | "text/rtf"
  | "application/rtf"
  | "image/jpeg"
  | "image/png"
  | "image/gif"
  | "image/webp";

// Interfaces
export interface ChatAttachment {
  uid: string;
  mime_type: ChatAttachmentMimeType;
  parsed_data: string | null;
  filename: string;
  size: number;
}

export interface GetAttachmentsResponse {
  attachments: ChatAttachment[];
}

// Axios request
export function getAttachments(
  chat_session_uid: string,
): Promise<AxiosResponse<GetAttachmentsResponse>> {
  return axios.get<GetAttachmentsResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/${chat_session_uid}/attachments`,
  );
}
